import { createFileRoute } from '@tanstack/react-router';

import { useOrgId } from '@/features/org/api';
import { usePageState } from '@/lib/page-state';
import { CreativeScreen, type CreativeSearch } from '@/screens/creative/CreativeScreen';

export const Route = createFileRoute('/_app/creative/')({
  component: CreativePage,
});

const INITIAL: CreativeSearch = {};

/** The view, the campaign or ad set opened and the element picked are page state kept in memory per org, not URL params. */
function CreativePage() {
  const orgId = useOrgId();
  const [search, patch] = usePageState(`${orgId}/creative/nav`, INITIAL);
  return <CreativeScreen search={search} onSearch={patch} />;
}
